var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_6638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5415 4.16683C13.3555 4.32563 14.1035 4.72371 14.6899 5.31011C15.2763 5.89651 15.6744 6.64455 15.8332 7.4585M12.5415 0.833496C14.2326 1.02136 15.8095 1.77864 17.0134 2.981C18.2173 4.18336 18.9765 5.75934 19.1665 7.45016M18.3332 14.1002V16.6002C18.3341 16.8322 18.2866 17.062 18.1936 17.2746C18.1006 17.4873 17.9643 17.6782 17.7933 17.8351C17.6222 17.9919 17.4203 18.1114 17.2005 18.1858C16.9806 18.2601 16.7477 18.2877 16.5165 18.2668C13.9522 17.9882 11.489 17.1119 9.32486 15.7085C7.31139 14.429 5.60431 12.722 4.32486 10.7085C2.91651 8.5345 2.04007 6.05932 1.76653 3.4835C1.7457 3.25305 1.77309 3.0208 1.84695 2.80152C1.9208 2.58224 2.03951 2.38074 2.1955 2.20985C2.3515 2.03896 2.54137 1.90242 2.75302 1.80893C2.96468 1.71544 3.19348 1.66705 3.42486 1.66683H5.92486C6.32928 1.66285 6.72136 1.80606 7.028 2.06977C7.33464 2.33349 7.53493 2.6997 7.59153 3.10016C7.69705 3.90022 7.89274 4.68577 8.17486 5.44183C8.28698 5.7401 8.31125 6.06426 8.24478 6.3759C8.17832 6.68753 8.02392 6.97359 7.79986 7.20016L6.74153 8.2585C7.92783 10.3448 9.65524 12.0722 11.7415 13.2585L12.7999 12.2002C13.0264 11.9761 13.3125 11.8217 13.6241 11.7552C13.9358 11.6888 14.2599 11.713 14.5582 11.8252C15.3143 12.1073 16.0998 12.303 16.8999 12.4085C17.3047 12.4656 17.6744 12.6695 17.9386 12.9814C18.2029 13.2933 18.3433 13.6915 18.3332 14.1002Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_6638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlue);
export default __webpack_public_path__ + "static/media/phone-blue.a37db5024dc6c73d7ec10f7ed3aa86ce.svg";
export { ForwardRef as ReactComponent };